import React, {useLayoutEffect} from "react";
import {useAuthDispatcher} from "../context/AuthContext";
import {actionTypes, setLoginStateDispatch} from "../context/reducer";
import {
    getUserRefreshToken,
    getUserToken,
    setUserRefreshToken,
    setUserToken
} from "../service/localStorage/LocalStorageService";
import {HttpClient} from "../service/httpClient/HttpClient";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../context/SnackBarContext";
import {LoginService} from "../pages/login/LoginService";
import {CashService} from "../pages/CashInfo/CashService";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../context/LoadingContext";
import jwt from "jwt-decode";
import {GeneralService} from "../pages/generalAdmin/GeneralService";
import {ServerErrorHandler} from "../service/httpClient/ServerErrorHandler";


export default function AuthorizationRoute(props) {

    const refreshToken = getUserRefreshToken()
    const dispatch = useAuthDispatcher()

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()

    const service = new LoginService()

    function setUserStateLogout() {
        setUserRefreshToken(null)
        setUserRefreshToken(null)

        dispatch({
            type: actionTypes.LOGOUT,
            loading: false,
            loginState: false,
            role: []
        })
    }

    function setUserLoginState(loginInfo, fundId, title, totalOwner) {
        setUserRefreshToken(loginInfo.refresh_token)

        dispatch(
            setLoginStateDispatch(
                actionTypes.LOGIN,
                loginInfo.access_token,
                "ADMIN",
                fundId,
                title,
                totalOwner))

        loading(setLoadingStateDispatch(false))
    }

    useLayoutEffect(() => {
        if (typeof service !== 'undefined') {
            if (refreshToken !== null) {
                service.getUserTokenByRefreshToken(refreshToken)
                    .then(response => {
                        getAvailableCashList(response.data)

                    }).catch(reason => {
                    setUserStateLogout()
                })
            } else {
                setUserStateLogout()
            }
        } else {
            setUserStateLogout()
        }
    }, [dispatch, refreshToken])

    function getAvailableCashList(loginInfo) {
        if (jwt(loginInfo.access_token).total_owner === true) {
            new GeneralService(
                loginInfo.access_token,
                loading,
                snackbar
            ).getAvailableCashList(0, 1)
                .then(response => {
                    console.log("total owner is true : ", jwt(loginInfo.access_token).total_owner)

                    if (response.data.length > 0) {
                        setUserLoginState(loginInfo, response.data[0].id, response.data[0].name, true)
                    }
                }).catch(reason => {
                ServerErrorHandler(reason, "خطا در دریافت لیست صندوق های در دسترس", snackbar, loading)
            })
        } else {
            new CashService(
                loginInfo.access_token,
                loading,
                snackbar
            ).getAvailableCashList()
                .then(response => {
                    console.log("total owner is false : ", jwt(loginInfo.access_token).total_owner)

                    if (response[0]) {
                        setUserLoginState(loginInfo, response[0].id, response[0].name, false)
                    } else {
                        snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "مدیریت هیچ صندوقی به شما تعلق نگرفته است!"))
                        loading(setLoadingStateDispatch(false))
                    }
                }).catch(reason => {
                loading(setLoadingStateDispatch(false))
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت اطلاعات صندوق"))
            })
        }
    }

    return (<>{props.children}</>)
}